(function() {
    'use strict';
    angular.module('wamasysApp').config(['$stateProvider', function($stateProvider) {
        $stateProvider.state('ai-costs', {
            parent: 'entity', url: '/ai-costs',
            data: { authorities: ['ROLE_SUPER_ADMIN'], pageTitle: 'Coûts IA (USD)' },
            views: { 'content@': { templateUrl: 'app/business/ai-costs/ai-costs.html', controller: 'AiCostsController', controllerAs: 'vm' } }
        });
    }]);
})();
